import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import "./error.css";
interface LoaderProps {
  msg: string;
}
const ErrorCard: React.FC<LoaderProps> = ({ msg }) => {
  return (
    <div className="error">
      <FontAwesomeIcon icon={faExclamationTriangle} className="errorLogo" />
      <div>{msg}</div>
    </div>
  );
};

export default ErrorCard;
